import { Box } from '@mui/material'
import { GridCellParams } from '@mui/x-data-grid-pro'

import useStyles from '../../index.styles'

const AlertTableMultilineText = (cellParams: GridCellParams<DeviceAlertTableRow, string>) => {
  const classes = useStyles

  return <Box sx={classes.alertsMultilineText}>{cellParams.value}</Box>
}

export default AlertTableMultilineText
